"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createTheme = require("./createTheme");

var _default = function _default(assets) {
  return (0, _createTheme.createTheme)({
    name: 'MedPlus',
    assets: assets,
    colors: {
      primary: '#5baea8',
      secondary: '#7159a2'
    }
  });
};

exports.default = _default;